import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
} from "./constants"

export function getDivisionsWatcher(payload) {
  return {
    type: GET_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed() {
  return { type: GET_DIVISIONS_FAILED }
}
